window.c.FollowUserApi = function () {
  function FollowUserApi() {}
  FollowUserApi.prototype.followUser = function (user_id, source, source_details) {
    return this._postFollow(user_id, 'POST', source, source_details).done(function () {
      var ref;
      return (ref = Aedu.User.current) != null ? ref.record_follow_of(user_id) : void 0;
    });
  };
  FollowUserApi.prototype.unfollowUser = function (user_id) {
    return this._postFollow(user_id, 'DELETE').done(function () {
      var ref;
      return (ref = Aedu.User.current) != null ? ref.record_unfollow_of(user_id) : void 0;
    });
  };
  FollowUserApi.prototype._postFollow = function (user_id, method, source, source_details) {
    var data;
    data = {
      _method: method
    };
    if (source != null) {
      data.source = source;
    }
    if (source_details != null) {
      data.source_details = source_details;
    }
    return $.ajax({
      url: $r.api_v0_user_following_index_path({
        user_id: user_id,
        subdomain_param: 'api'
      }),
      type: 'POST',
      data: data
    });
  };
  FollowUserApi.prototype.blockUser = function (user_id) {
    return this._postBlock(user_id, 'POST');
  };
  FollowUserApi.prototype.unblockUser = function (user_id) {
    return this._postBlock(user_id, 'DELETE');
  };
  FollowUserApi.prototype._postBlock = function (user_id, method) {
    return $.ajax({
      url: $r.api_v0_user_blocks_path({
        user_id: user_id,
        subdomain_param: 'api'
      }),
      type: 'POST',
      data: {
        _method: method
      }
    });
  };
  return FollowUserApi;
}();
window.Follow = new c.FollowUserApi();